<div class="flex flex-col-reverse lg:grid lg:grid-cols-4 justify-between">
  <app-news class="lg:col-span-3"></app-news>
  <app-details class="flex items-center lg:col-span-1 lg:ml-10 xl:ml-28"></app-details>
</div>
<app-introduction></app-introduction>
<app-blog-intro></app-blog-intro>
<app-question id="question"></app-question>
